import TruckPermitRuleModal from './TruckPermitRuleModal';

export default TruckPermitRuleModal;
